import { render, staticRenderFns } from "./PersonDistinctGender.vue?vue&type=template&id=0be1bc93&"
import script from "./PersonDistinctGender.vue?vue&type=script&lang=js&"
export * from "./PersonDistinctGender.vue?vue&type=script&lang=js&"
import style0 from "./PersonDistinctGender.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonDistinctGender.vue"
export default component.exports